import React from "react";
import Slider from "react-slick";
import "./exciting-offers-slider.scss";

const ExcitingOffersSlider = ({ offerImages = [], navigate }) => {
  let ExcitingSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 812,
        settings: {
          slidesToShow: offerImages?.length > 3 ? 3 : offerImages?.length,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          initialSlide: 0.5,
          slidesToScroll: 1,
          slidesToShow: 1.5,
        },
      },
    ],
  };

  const handleImageClick = async (data) => {
    if (data?.providerId) {
      try {
        const encodedValue = encodeURIComponent(data?.providerId);
        navigate(`seller?pid=${encodedValue}`);
      } catch (error) { }
    } else {
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <Slider {...ExcitingSettings} className="exciting-offer-slider-kl">
              {offerImages.map((image, index) => (
                <div onClick={() => handleImageClick(image)} className="exciting-offer-item-kl" key={index}>
                  <img src={image?.value} alt={`Exciting offer ${index + 1}`} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExcitingOffersSlider;
